export const currencies = [
	{
		id: "pln",
		code: "PLN",
		default: true,
		name: "Polski Złoty",
	},
];
